import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { GlobalMetaDataEntity } from '../global-metadata.entity';

export const STATE_NAME = 'globalMetaDataEntity';

export const GlobalMetaDataEntityState: GenericEntityStateClass<GlobalMetaDataEntity> =
  createEntityState<GlobalMetaDataEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class GlobalMetaDataEntityService extends EntityService<GlobalMetaDataEntity> {
  constructor() {
    super();
    this.resourceType = 'global-metadata';
    this.stateClass = GlobalMetaDataEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): GlobalMetaDataEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
